import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { PageHeader, Tag, Button, Tooltip } from 'antd';
import { AuditOutlined } from '@ant-design/icons';

import { pageHeaderStyle, pageTitle } from '../util/Style';

import { AgGridReact } from 'ag-grid-react';

import ProductListStore from '../stores/ProductListStore';

const height = window.innerHeight * .80;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
    width: 100,
};

const columnDefs = [
    { headerName: 'Id', field: 'Testid', pinned: 'left', type: 'numberColumn' },
    {
        headerName: 'Status',
        field: 'price_update_flag',
        width: 10,
        pinned: 'left',
        type: 'numberColumn',
        cellStyle: params => {
            if (params.value === 2) {
                return { color: 'white', backgroundColor: 'rgb(27,160,97)' };
            }
            if (params.value === 1) {
                return { color: 'black', backgroundColor: 'rgb(255,230,114)' };
            }
            return { color: 'white', backgroundColor: 'rgb(204,47,16)' };
        }
    },
    { headerName: 'Code', field: 'Testcode', pinned: 'left', width: 100 },
    { headerName: 'Name', field: 'Testname', filter: 'agTextColumnFilter', pinned: 'left', width: 300 },
    { headerName: 'Lab Price', field: 'labPrice', width: 50 },
    { headerName: 'Self Price', field: 'selfPrice', width: 50 },
    { headerName: 'Department', field: 'DepartmentId', width: 50 },
    { headerName: 'Samples', field: 'Sampletype', width: 150 },
    { headerName: 'Parameters', width: 150 },
    { headerName: 'Instructions', field: 'Special_instructions', width: 150 }

];

class TestListUI extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = new ProductListStore({ apiProxy: props.appStore.apiProxy })
    }

    fetchTestData = () => {
        this.store.fetchTests();
    }

    countTag = () => {
        if (this.store.isDone) {
            return <Tag color="#108ee9">{this.store.rowCount} Total</Tag>
        }

        if (this.store.isError) {
            return <Tag color="red">...</Tag>
        }
    }

    exportCsv = () => {
        return(
            <Button onClick={() => this.onBtExport()} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }} >Export CSV</Button>
        )
    }

    onBtExport = async () => {
        await this.gridRef.current.api.exportDataAsCsv();
    };

    approvePrice = async () => {
        await this.store.approve();
        this.gridRef.current.api.redrawRows();
    }

    approveButton = () => {
        if (this.props.appStore.isHead) {
            return (
                <Tooltip title="The preferred prices of every tests and profiles, assigned to Labs, will be considered as their respective Approved Price.">
                    <Button onClick={() => this.approvePrice()} shape="round" style={{ background: "rgb(27,160,97)", color: "white" }} disabled={this.store.isLoading} icon={<AuditOutlined />}>Approve Price for All Labs</Button>
                </Tooltip>
            )
        }
    }


    onSelectionChanged = () => {
        const selectedRows = this.gridRef.current.api.getSelectedRows();

        const productId = selectedRows[0].Testid;
        const productName = selectedRows[0].Testname;
        const departmentId = selectedRows[0].DepartmentId;
        const labPrice = selectedRows[0].labPrice;
        const selfPrice = selectedRows[0].selfPrice;
        const priceUpdateFlag = selectedRows[0].price_update_flag

        const params = { parentKey: "products", kind: "test", productId, productName, departmentId, labPrice, selfPrice, priceUpdateFlag };

        this.props.appStore.currentComponent = { label: "Product Price", key: "priceList", params: params };
    }

    render() {
        const products = this.store.products;
        return (
            <>
                <PageHeader
                    style={pageHeaderStyle}
                    title={pageTitle("Tests")}
                    tags={this.countTag()}
                    extra={[
                        this.exportCsv(),
                        this.approveButton()
                    ]}
                >
                </PageHeader>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        rowHeight={30}
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={products}
                        rowSelection={'single'}
                        onSelectionChanged={this.onSelectionChanged}
                        columnDefs={columnDefs}
                        onGridReady={this.fetchTestData}>
                    </AgGridReact>
                </div>
            </>
        )
    }
}

export default observer(TestListUI)
